import { Fab } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import DeleteDialog from "../../DeleteDialog";
import FormDialogOfficer from "../../FormDialogOfficer";
import TableOfficer from "../../TableOfficer";
import { Officer } from "../../../interfaces";
import { officerActions, officerSelectors } from "../../../redux";

const useStyles = makeStyles((theme) => ({
  actionButtons: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
}));

const OfficerPage = () => {
  const [selectedOfficer, setSelectedOfficer] = useState<Officer | undefined>();
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState<boolean>(false);
  const [deleteId, setDeleteId] = useState("");
  const [officerDialogOpen, setOfficerDialogOpen] = useState(false);
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleDeleteDialogOpen = (id: string) => {
    setDeleteId(id);
    setIsDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialogOpen = () => {
    dispatch(officerActions.clear("deletedOfficer"));
    dispatch(officerActions.loadAllOfficer({}));
    setIsDeleteDialogOpen(false);
  };

  const handleEditOfficer = (officer: Officer | undefined) => {
    setSelectedOfficer(officer);
    setOfficerDialogOpen(true);
  };

  const handleCreateNewOfficer = () => {
    setSelectedOfficer(undefined);
    setOfficerDialogOpen(true);
  };

  return (
    <>
      <div className={classes.actionButtons}>
        <Fab
          onClick={handleCreateNewOfficer}
          variant="extended"
          color="primary"
        >
          <AddIcon></AddIcon>Crea nuovo Ente
        </Fab>
      </div>
      <TableOfficer
        onDeleteOfficer={handleDeleteDialogOpen}
        onEditOfficer={handleEditOfficer}
      />
      <DeleteDialog
        isOpen={isDeleteDialogOpen}
        onClose={handleCloseDeleteDialogOpen}
        deleteAction={officerActions.deleteOfficerById}
        selector={officerSelectors.getDeletedOfficer}
        id={deleteId}
      />
      {selectedOfficer ? (
        <FormDialogOfficer
          officerToUpdate={selectedOfficer}
          isOpen={officerDialogOpen}
          onClose={() => setOfficerDialogOpen(false)}
        />
      ) : (
        <FormDialogOfficer
          isOpen={officerDialogOpen}
          onClose={() => setOfficerDialogOpen(false)}
        />
      )}
    </>
  );
};

export default OfficerPage;
